import React, { useState, useEffect } from "react";
import axios from "axios";
import { config } from "../../../config/const";
import "./CommentSection.css";

const CommentSection = ({ storyId }) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editingCommentText, setEditingCommentText] = useState("");

  const fetchComments = async () => {
    try {
      const response = await axios.get(`${config.backend_url}/user/comments`, {
        params: { story_id: storyId },
      });
      setComments(response.data.comments);
    } catch (error) {
      console.error(error);
    }
  };

  const handleAddComment = async () => {
    const email = localStorage.getItem("email");
    try {
      await axios.post(`${config.backend_url}/user/comment`, {
        story_id: storyId,
        email,
        comment: newComment,
      });
      setNewComment("");
      fetchComments();
    } catch (error) {
      console.error(error);
    }
  };

  const handleEditComment = async (commentId) => {
    const email = localStorage.getItem("email");
    try {
      console.log(email);
      await axios.put(`${config.backend_url}/user/comment`, {
        comment_id: commentId,
        comment: editingCommentText,
        email,
      });
      setEditingCommentId(null);
      setEditingCommentText("");
      fetchComments();
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeleteComment = async (comment_id) => {
    const email = localStorage.getItem("email");
    try {
      await axios.delete(`${config.backend_url}/user/comment`, {
        params: { comment_id, email },
      });
      fetchComments();
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchComments();
  }, []);

  return (
    <div className="comment-section">
      <h3>Comments</h3>
      <div className="add-comment">
        <textarea
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="Add a comment..."
        />
        <button onClick={handleAddComment}>Post Comment</button>
      </div>
      <div className="comments-list">
        {comments.map((comment) => (
          <div key={comment._id} className="comment">
            {editingCommentId === comment._id ? (
              <div className="edit-comment">
                <textarea
                  value={editingCommentText}
                  onChange={(e) => setEditingCommentText(e.target.value)}
                />
                <button onClick={() => handleEditComment(comment._id)}>
                  Save
                </button>
                <button onClick={() => setEditingCommentId(null)}>
                  Cancel
                </button>
              </div>
            ) : (
              <div className="comment-content">
                <p>{comment.text}</p>
                <button
                  onClick={() => {
                    setEditingCommentId(comment._id);
                    setEditingCommentText(comment.text);
                  }}
                >
                  Edit
                </button>
                <button onClick={() => handleDeleteComment(comment._id)}>
                  Delete
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommentSection;
